import React, { useEffect, useState } from "react"
import {  CheckBox, TextArea, TextBox} from 'devextreme-react';
import DateBox from "../../../../common/CustomDateBox";
import SelectBox from "../../../../common/CustomSelectBox"
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { getProvinces } from "../../../../../redux/provinces/thunks";
import { selectProvinces } from "../../../../../redux/provinces/selectors";
import { baseRequest } from "../../../../../fetch/basicThunk";
import { QUERY_GET_EMAIL_FROM_TEMPLATE } from "../../../../../fetch/constantQueries";
import { EmailCodeTemplates } from "../../../../../Constantes/emailCodeTemplates";
import { Divider } from "@material-ui/core";

function MarshForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode);
const provinces = useSelector(selectProvinces);
const selectOptions = ["Sí", "No"]

useEffect(()=>{

    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    dispatch(getProvinces());
    if(types && types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
    loadRecipients();

    return ()=> onChange("emails", "")
},[])

async function loadRecipients(){
    const recipientData = await baseRequest({query:`?templateCode=${EmailCodeTemplates.OUT_OF_TIME_SINISTER}`}, dispatch, QUERY_GET_EMAIL_FROM_TEMPLATE, "POST")
 
    if(recipientData.value.length > 0){
        let resultToString = recipientData.value.filter(emailRecipient =>{return !emailRecipient.isCC;}).map(emailRecipient => emailRecipient.emailAddress).join("; ")
        const ccEmails = recipientData.value.filter(emailRecipient =>{return emailRecipient.isCC;}).map(emailRecipient => emailRecipient.emailAddress).join("; ")
        if(ccEmails?.length > 0) resultToString += `;${ccEmails}`;
        onChange("emails", resultToString);
      }
}

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
},[types])

function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                   <div className="grid-two-columns">
                        <TextBox label={"Dirección"} labelMode="floating"key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)}  ></TextBox>
                        <SelectBox label={"Provincia"} placeholder=" " key={"province"} name="province" value={dataForm?.province} dataSource={provinces} onValueChanged={(e) => onChange("province", e.value)}></SelectBox>
                   </div>
                        <TextBox label={"Daños en el vh"} labelMode="floating"key={"damage"} name="damage" value={dataForm?.damage} onValueChanged={(e) => onChange("damage",e.value)}  ></TextBox>
                    <div className="grid-two-columns">
                        <SelectBox label={"Quiere reparar?"} placeholder=" " key={"wantToRepair"} name="wantToRepair" dataSource={selectOptions} value={dataForm?.wantToRepair} onValueChanged={(e) => onChange("wantToRepair",e.value)}  ></SelectBox>
                        <DateBox label={"Fecha y hora"} displayFormat={"dd/MM/yyyy HH:mm"} applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.date} onValueChanged={(e) => changeDate("date", e.value)}  ></DateBox>
                    </div>
                    <div className={"grid-four-columns"}>                    
                        <SelectBox label={"Lesiones"} placeholder=" " key={"injury"} name="injury" dataSource={selectOptions} value={dataForm?.injury} onValueChanged={(e) => onChange("injury",e.value)}  ></SelectBox>                    
                        <SelectBox label={"Atestado"} placeholder=" " key={"report"} name="report" dataSource={selectOptions} value={dataForm?.report} onValueChanged={(e) => onChange("report",e.value)}  ></SelectBox>
                        <SelectBox label={"Grúa"} placeholder=" " key={"towTruck"} name="towTruck" dataSource={selectOptions} value={dataForm?.towTruck} onValueChanged={(e) => onChange("towTruck",e.value)}  ></SelectBox>             
                        <SelectBox label={"Decl. amistosa"} placeholder=" " key={"amicableDeclaration"} name="amicableDeclaration" dataSource={selectOptions} value={dataForm?.amicableDeclaration} onValueChanged={(e) => onChange("amicableDeclaration",e.value)}  ></SelectBox>
                    </div>                                     
                    <div className="grid-two-columns">
                        <TextBox label={"Nome"} labelMode="floating"key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                        <TextBox label={"Apellidos"} labelMode="floating"key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                    </div>
                    <div className={classes.input_grid}>                           
                        <TextBox label={"Móvil"} labelMode="floating"key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                        <TextBox label={"Correo electrónico"} labelMode="floating"key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>                            
                    </div>
                    <div>
                        <div>{"Vehículo contrario"}</div> 
                        <Divider orientation="horizontal"/>
                    </div>
                    <div className={classes.input_grid}>       
                        <TextBox label={"Matrícula"} labelMode="floating"key={"otherPlate"} name="otherPlate" value={dataForm?.otherPlate} onValueChanged={(e) => onChange("otherPlate",e.value)}  ></TextBox>
                        <TextBox label={"Marca"} labelMode="floating"key={"otherBrand"} name="otherBrand" value={dataForm?.otherBrand} onValueChanged={(e) => onChange("otherBrand",e.value)}  ></TextBox>
                    </div>
                    <TextBox label={"Modelo"} labelMode="floating"key={"otherModel"} name="otherModel" value={dataForm?.otherModel} onValueChanged={(e) => onChange("otherModel",e.value)}  ></TextBox>
                    <TextBox label={"Compañía de seguros"} labelMode="floating"key={"otherInsurance"} name="otherInsurance" value={dataForm?.otherInsurance} onValueChanged={(e) => onChange("otherInsurance",e.value)}  ></TextBox>
                    <div className="grid-two-columns">
                        <TextBox label={"Nome"} labelMode="floating"key={"otherName"} name="otherName" value={dataForm?.otherName} onValueChanged={(e) => onChange("otherName",e.value)}  ></TextBox>
                        <TextBox label={"Apellidos"} labelMode="floating"key={"otherSurname"} name="otherSurname" value={dataForm?.otherSurname} onValueChanged={(e) => onChange("otherSurname",e.value)}  ></TextBox>
                    </div>
                    <TextBox label={"Daños del vh"} labelMode="floating"key={"otherDamage"} name="otherDamage" value={dataForm?.otherDamage} onValueChanged={(e) => onChange("otherDamage",e.value)}  ></TextBox>
                    <TextArea labelMode="floating" label={"Versión de lo ocurrido"} key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)}  height={144}></TextArea>
                    <div className="grid-two-columns">
                        <div className="template-checkbox-container">
                            <CheckBox value={dataForm?.sendMail} onValueChanged={(e) => onChange("sendMail", e.value)}></CheckBox>
                            <label>Enviar email</label>
                    </div>
                </div>
                {dataForm?.sendMail &&
                <TextArea label={"Destinatarios"} labelMode="floating" maxLength={1000} valueChangeEvent="keyup" onValueChanged={(e)=>onChange("emails" , e.value)} value={dataForm.emails}  height={144}></TextArea>
                }
        </div>
    )
}

export { MarshForm }